import { useIntl } from '@alltrails/shared/react-intl';
import Rating from '@material-ui/lab/Rating';
import EmptyIcon from '../../../../assets/images/icons/icons_stars_inactive_lrg.svg';
import FullIcon from '../../../../assets/images/icons/icons_stars_active_lrg.svg';
import * as defaultStyles from './styles/default.module.scss';
import * as filterStyles from './styles/filter.module.scss';

type Props = {
  config: number | string; // todo should be number but I think we have some existing string code in the app
  handler?: (e: React.ChangeEvent, rating: number | null) => void;
  iconClassName?: string;
};

// Note: StarRating component renders very inefficiently when loading multiple stars on trail result cards in fullscreen search result list,
// TODO: Let's look at using a different framework or building this custom
const StarRating = ({ config, handler, iconClassName = '' }: Props) => {
  const intl = useIntl();
  const styles = handler ? filterStyles : defaultStyles;

  return (
    <Rating
      className={styles.rating}
      name="rating"
      size="large"
      value={typeof config === 'number' ? config : parseFloat(config)}
      onChange={handler}
      icon={<img className={iconClassName} alt={intl.formatMessage({ defaultMessage: 'Yellow star' })} src={FullIcon} />}
      emptyIcon={<img className={iconClassName} alt={intl.formatMessage({ defaultMessage: 'Gray star' })} src={EmptyIcon} />}
      precision={handler ? 1 : 0.5}
      readOnly={!handler}
    />
  );
};

export default StarRating;
